import React from 'react';
import CoordinatorsTable from './CoordinatorsTable';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {ROLES, withRoles} from "../Permissions";
import {BASENAME} from "../../constants";

const CoordinatorManagement = () => (
    <div>
        <Typography variant="h3" gutterBottom>
            User Management
        </Typography>
        <Button href={BASENAME + "/users/new"} variant="contained" color='secondary'>
            Add New User
        </Button>
         <CoordinatorsTable/>
    </div>
);

export default withRoles([ROLES.ADMIN])(CoordinatorManagement);
